import React from 'react';
import { Helmet, HelmetProps } from 'react-helmet';

import ShortcutIcon from '../../images/favicon.png';

interface IHeadProps {
  /** 网页标题 */
  title?: string;
  /** 网页权威链接 */
  canonical?: string;
  /** 网页描述 */
  description?: string;
  /** 网页封面图 */
  cover?: string;
  linkList?: Array<any>;
  htmlAttr?: HelmetProps['htmlAttributes'];
  ogUrl?: string;
  children?: any;
}

const Head: React.FC<IHeadProps> = ({ title, description, canonical, cover, linkList, htmlAttr, ogUrl, children }) => {
  return (
    <Helmet htmlAttributes={htmlAttr}>
      {/* Title */}
      {title && <title>{title}</title>}
      {title && <meta property="og:title" content={title} />}
      {title && <meta property="twitter:title" content={title} />}

      {/* Description */}
      {description && <meta name="description" content={description} />}
      {description && <meta content={description} property="og:description" />}
      {description && <meta content={description} property="twitter:description" />}

      {/* Cover */}
      {cover && <meta content={cover} property="og:image" />}
      {cover && <meta content={cover} property="twitter:image" />}

      {/* Canonical */}
      {canonical && <link rel="canonical" href={canonical} />}

      {/* GTM */}
      <meta content="MUz9E0qJ1-cAL-F8JfLLi7GP8jW0OwGeBFOGedyaCp0" name="google-site-verification" />

      {/* shortcut icon */}
      <link href={ShortcutIcon} rel="shortcut icon" type="image/x-icon" />

      {linkList &&
        linkList.map((item) => {
          return item;
        })}

      {/* Other */}
      <meta property="og:type" content="website" />
      <meta content="summary_large_image" name="twitter:card" />
      <meta name="facebook-domain-verification" content="lo0grjsfnmes4br0rpgznzprfatmv0" />
      <meta property="og:url" content={ogUrl} />
      {children}
    </Helmet>
  );
};

export default Head;
